import { apiFetch } from "@/lib/api";

export async function fetchAiModels(): Promise<any[]> {
  const response = await apiFetch("/api/models");
  if (!response.ok) throw new Error("Failed to fetch models");
  return response.json();
}

export async function fetchShowCharacters(showId: string): Promise<any[]> {
  const response = await apiFetch(`/api/shows/${showId}/characters`);
  if (!response.ok) throw new Error("Failed to fetch characters");
  return response.json();
}

export async function expandPrompt(
  showId: string,
  body: Record<string, any>,
): Promise<any> {
  const response = await apiFetch(`/api/shows/${showId}/artifacts/preview`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new Error(data?.error || "Failed to preview prompt");
  return data;
}

export async function createArtifact(
  showId: string,
  body: Record<string, any>,
): Promise<any> {
  const response = await apiFetch(`/api/shows/${showId}/artifacts`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Failed to save artifact");
  return response.json().catch(() => null);
}

export async function updateArtifact(
  showId: string,
  artifactId: string,
  body: Record<string, any>,
): Promise<any> {
  const response = await apiFetch(
    `/api/shows/${showId}/artifacts/${artifactId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
  );
  if (!response.ok) throw new Error("Failed to overwrite artifact");
  return response.json().catch(() => null);
}

export async function deleteArtifact(
  showId: string,
  artifactId: string,
): Promise<void> {
  const response = await apiFetch(
    `/api/shows/${showId}/artifacts/${artifactId}`,
    {
      method: "DELETE",
    },
  );
  if (!response.ok) throw new Error("Failed to delete artifact");
}
